<template>
    <div class="container">
        <section class="section">
            <div class="u-mb-3">
                <div class="u-mb-3 u-pb-0-5"></div>
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                    <div class="d-flex flex-gap-8 align-items-center u-mt-0-5">
                        <div class="h2 font-weight--bold u-mb-0 line-height--h3">Settings</div>
                    </div>
                </div>
            </div>
            <div class="section__content">
                <ul class="nav nav-tabs d-none d-lg-flex justify-content-start nav-tabs" role="tablist">
                    <li class="nav-item">
                        <button @click="$router.push('/settings/profile')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Profile</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/preferences')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Preferences</span></div>
                        </button>
                    </li>
                    <li class="nav-item nav-item--active">
                        <button @click="$router.push('/settings/verification')" class="btn btn--tertiary btn--block nav-link nav-link--active rounded-0 m-auto"
                                type="button" data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="true">
                            <div class="nav-link__tab"><span class="nav-link__label">Verification</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/security')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Security</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/payment-methods')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Payment methods</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/apps')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Apps</span></div>
                        </button>
                    </li>
                    <li class="nav-item">
                        <button @click="$router.push('/settings/limits')" class="btn btn--tertiary btn--block nav-link rounded-0 m-auto" type="button"
                                data-loading="false" aria-expanded="false" data-toggle="tab" role="tab"
                                aria-selected="false">
                            <div class="nav-link__tab"><span class="nav-link__label">Limits</span></div>
                        </button>
                    </li>
                </ul>
                <div class="dropdown d-block d-lg-none tabs-dropdown">
                    <div class="dropdown-toggle d-block w-100 py-1" id="settings-toggle" aria-haspopup="true"
                         aria-expanded="false"><h4 class="m-0">Verification</h4></div>
                </div>
                <hr class="d-block d-lg-none mt-0">
                <p class="font-weight--bold text--base text--sm u-mb-2 u-mt-4">Airtm verification</p>
                <div class="card u-p-4 card--translucent position-relative z-1">
                    <div class="d-flex">
                        <div class="col-md-1 u-mr-3 u-p-0 d-none d-md-block">
                            <img alt="airtm-verification" src="@/assets/img/airtm-verification.png">
                        </div>
                        <div class="d-flex w-100">
                            <div class="d-flex flex-column flex-gap-16">
                                <div class="d-flex flex-column flex-gap-16">
                                    <div class="d-flex"><span
                                            class="status-bubble status-bubble--completed status-bubble--with-borders">Verification approved</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column flex-gap-16"><p class="text--sm m-0">You can currently
                                    send and withdraw up to $25,000 in total! Once you reach this amount, you will need
                                    enhanced verification.</p></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "verification",
    }
</script>

<style scoped>

</style>